
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enroll",
      function () {
        return require("private-next-pages/enroll/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enroll"])
      });
    }
  